export default __webpack_public_path__ + "static/media/thumbnail4.f0e0fe68.jpg";